import { render, staticRenderFns } from "./EditIndex.vue?vue&type=template&id=690d68c1&scoped=true"
import script from "./EditIndex.vue?vue&type=script&lang=js"
export * from "./EditIndex.vue?vue&type=script&lang=js"
import style0 from "./EditIndex.vue?vue&type=style&index=0&id=690d68c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690d68c1",
  null
  
)

export default component.exports